<script setup lang="ts">
  import { Text, Button } from "@ui-kit";
  import { Image } from "@src/components";

  const {
    image_url,
    title,
    article,
    color,
    is_linked = false,
  } = defineProps<{
    image_url: string;
    title: string;
    article: string;
    color?: string;
    is_linked?: boolean;
  }>();
  const emit = defineEmits<{ (e: "click:link"): void }>();
</script>

<template>
  <div class="not-binding-item" data-testid="not-binding-item">
    <div class="not-binding-item__content">
      <Image :url="image_url" />
      <div class="not-binding-item__info">
        <Text font="body-medium-16">{{ article }}</Text>
        <Text font="body-regular-14" color="secondary">
          {{ `${color}, ${title}` }}
        </Text>
      </div>
    </div>
    <Button size="s" :disabled="is_linked" data-testid="not-binding-item-link-btn" @click="emit('click:link')">
      {{ is_linked ? $t("Привязано") : $t("Привязать к текущей зоне") }}
    </Button>
  </div>
</template>

<style scoped>
  .not-binding-item {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);

    & :deep(.button) {
      width: 100%;
    }
  }

  .not-binding-item__content {
    display: flex;
    gap: 12px;

    & :deep(.image) {
      width: 48px;
      height: 62px;
    }
  }

  .not-binding-item__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
</style>
